export const version = '3.670.0'
